import styled from 'styled-components';
const Iframe = styled.iframe `
  display: block;
  width: 100%;
  aspect-ratio: 16 / 9;
  height: auto;
  max-width: ${({ $maxWidth }) => `${$maxWidth}px`};
`;
export default {
    Iframe,
};
